// @flow

import PropTypes from 'prop-types';
import styled from 'styled-components';

import DisplayText from '../Text/DisplayText';

const ButtonContainer = styled.button`
  height: ${props => 64 * props.scale}px;
  width: ${props => 64 * props.scale}px;
  border-radius: ${props => 32 * props.scale}px;
  background-color: ${props => props.theme.btnBrand};
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;

  &:active {
    background-color: ${props => props.theme.btnBrandClicked};
  }

  &:hover:not(:active) {
    background-color: ${props => props.theme.btnBrandHover};
  }

  &:focus {
    outline: 0;
  }
`;

const Label = styled(DisplayText)`
  width: 100%;
  text-align: center;

  ${ButtonContainer}:active & {
    color: ${props => props.theme.brand};dis
  } 
`;

const IconContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Icon = styled.img`
  width: ${props => 32 * props.scale}px;
  height: ${props => 21 * props.scale}px;

  ${ButtonContainer}:active & {
    fill: ${props => props.theme.brand};
  }
`;

type Props = {
  icon?: string,
  text?: string,
  scale: number,
  onPress: () => void
};

export function PinPadButton({ text, icon, onPress, scale }: Props) {
  const fontSize = 32 * scale + 'px';
  return (
    <ButtonContainer onClick={onPress} scale={scale}>
      {Boolean(text) && (
        <Label fontSize={fontSize} bold>
          {text}
        </Label>
      )}
      {Boolean(icon) && (
        <IconContainer>
          <Icon src={icon} scale={scale} />
        </IconContainer>
      )}
    </ButtonContainer>
  );
}

PinPadButton.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  onPress: PropTypes.func,
  scale: PropTypes.number
};

export default PinPadButton;
